import type { ReactNode } from 'react'

import { PropertiesTag } from '@graftcode/design-system'

import { getBadgeType } from '@/core/utils/getBadgeType'
import { getPropertiesTagVariant } from '@/core/utils/getPropertiesTagVariant'

import styles from './createTitleWithBadge.module.scss'

export function createTitleWithBadge(title: ReactNode, badge?: string, badgeClassName?: string): ReactNode {
  if (!badge) {
    return title
  }

  const badgeVariant = getPropertiesTagVariant(getBadgeType(badge))

  return (
    <div className={styles.titleWithBadge}>
      <span className={styles.title}>{title}</span>
      <PropertiesTag variant={badgeVariant} withoutIcon className={badgeClassName}>
        {badge}
      </PropertiesTag>
    </div>
  )
}
